import React from "react";
import ChatUser from "./chat-user";
const ChatUserList = ({
  userList,
  handleSelectChatRoom,
  setUserChatWith,
  searchTerm,
  setSearchTerm,
}) => {
  return (
    <div className="col-lg-4 chat-cont-left ">
      <div className="card mb-0 flex-fill">
        <div className="chat-header">
          <div className="mb-3">
            <h6>Chats</h6>
          </div>
          <div className="input-icon">
            <span className="input-icon-addon">
              <i className="isax isax-search-normal-14"></i>
            </span>
            <input
              type="email"
              className="form-control form-control-md"
              placeholder="Search"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
        </div>
        <div className="card-body chat-users-list chat-scroll pt-0">
          {userList.map((user, index) => (
            <ChatUser
              key={index}
              user={user}
              handleSelectChatRoom={handleSelectChatRoom}
              setUserChatWith={setUserChatWith}
            />
          ))}
          {/* <a
            href="#"
            className="d-flex justify-content-between chat-member mb-3"
          >
            <div className="d-flex align-items-center">
              <div className="avatar avatar-lg online flex-shrink-0 me-2">
                <img src="assets/img/users/user-32.jpg" alt="User Image" />
              </div>
              <div>
                <h6 className="fs-16 fw-medium mb-1">Adrian Marshall</h6>
                <p className="fs-14 text-gray-6">Have you called them?</p>
              </div>
            </div>
            <div className="flex-grow-1">
              <div className="text-end">
                <p className="mb-1 fs-14 text-gray-6">Just Now</p>
                <div className="d-flex justify-content-end">
                  <span className="msg-count badge badge-primary d-flex align-items-center justify-content-center rounded-circle">
                    1
                  </span>
                </div>
              </div>
            </div>
          </a> */}
        </div>
      </div>
    </div>
  );
};

export default ChatUserList;
